


































import { Component, Prop, Vue } from 'vue-property-decorator';
import {  ActivityHistories } from '@/@types/LibraryComponent';
import AccountIcon from '@/components/common/AccountIcon.vue';

@Component({
  components: {
    AccountIcon
  }
})
export default class ActivityList extends Vue {
  @Prop({ default: null })
  private activityHistories!: Array<ActivityHistories>;

}
